import React from 'react';

export default ({ formName, record }) => {
  return <span>{ formName } { record ? `${record.name || record.idNumber || record.breedNameBg || record.ageGroup || ''}` : '' }</span>;
};
